module.exports = __webpack_public_path__ + "img/classify-item5.8ae8bb80.png";